import AuthAPI from '../api/auth';
import BaseActionCableConnector from '../../shared/helpers/BaseActionCableConnector';
import DashboardAudioNotificationHelper from './AudioAlerts/DashboardAudioNotificationHelper';
import { MESSAGE_STATUS } from 'shared/constants/messages';
import { shouldRemoveConversation } from './conversationRemovalHelper';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import { routes as conversationRoutes } from '../../dashboard/components/layout/config/sidebarItems/conversations';
import { routes as boardRoutes } from '../../dashboard/components/layout/config/sidebarItems/boards';


const AWAIT_CHECK_MESSAGE_INTERVAL = 1000;
const SYNC_MESSAGES_AFTER_CHECK_INTERVAL = 10000;
const ALERT_DISCONNECTED_INTERVAL = 20000;
const SYNC_RECONNECT_MAX_JITTER_MS = 60000; // 1 minute

class ActionCableConnector extends BaseActionCableConnector {
  constructor(app, pubsubToken) {
    const { websocketURL = '' } = window.chatwootConfig || {};
    super(app, pubsubToken, websocketURL);    
    this.CancelTyping = [];
    this.lastDisconnectedAt = null;
    this.syncReconnectTimer = null;
    this.events = {
      'message.created': this.onMessageCreated,
      'message.updated': this.onMessageUpdated,
      'conversation.created': this.onConversationCreated,
      'conversation.status_changed': this.onStatusChange,
      'user:logout': this.onLogout,
      'page:reload': this.onReload,
      'assignee.changed': this.onAssigneeChanged,
      'conversation.typing_on': this.onTypingOn,
      'conversation.typing_off': this.onTypingOff,
      'conversation.contact_changed': this.onConversationContactChange,
      'presence.update': this.onPresenceUpdate,
      'contact.deleted': this.onContactDelete,
      'contact.updated': this.onContactUpdate,
      'conversation.mentioned': this.onConversationMentioned,
      'notification.created': this.onNotificationCreated,
      'first.reply.created': this.onFirstReplyCreated,
      'conversation.read': this.onConversationRead,
      'conversation.updated': this.onConversationUpdated,
      'account.cache_invalidated': this.onCacheInvalidate,
      'conversation.merged': this.onConversationMerge,
      'assistant.created': this.onAssistentCreated,
      'conversation.team_updated': this.onTeamUpdated,
      'calllog.updated': this.onCallLogUpdated,
      'whatsapp.sync_finished': this.onWhatsappSyncFinished,
      'campaign.file_import_analyzed': this.onCampaignFileImportAnalyzed,
      'opportunity.status_changed': this.onOpportunityUpdated,
      'opportunity.stage_changed': this.onOpportunityUpdated,
      'opportunity.value_changed': this.onOpportunityUpdated,
      'opportunity.owner_changed': this.onOpportunityUpdated,
      'opportunity.overdue': this.onOpportunityUpdated,
      'opportunity.temperature_changed': this.onOpportunityUpdated,
      'opportunity.created': this.onOpportunityCreated,
      'opportunity_activity.created': this.onOpportunityActivitiesChanged,
      'opportunity_activity.completed': this.onOpportunityActivitiesChanged,
      'opportunity_activity.rescheduled': this.onOpportunityActivitiesChanged,
      'opportunity_activity.canceled': this.onOpportunityActivitiesChanged,
      'internal_message.created': this.onInternalMessageCreated,
      'internal_conversation.read': this.onInternalConversationRead,
    };
    this.consumer.subscriptions.create(
      {
        channel: 'RoomAccountMessageChannel',
        account_token: this.app.$store.getters.getCurrentAccountId,
        pubsub_token: pubsubToken,
        user_id: this.app.$store.getters.getCurrentUserID,
      },
      {
        received: this.onReceivedMessageAccountCheck
      }
    );
    this.altertDisconnectedTimer = null;
  }

  conversationsIds = [];
  syncChatMessageTimer = null;
  initSyncChatMessageTimer = () => {
    if (this.syncChatMessageTimer !== null) {      
      clearTimeout(this.syncChatMessageTimer);
    }
    this.syncChatMessageTimer = setTimeout(() => {      
      this.app.$store.dispatch('setSyncMessagesInConversations', {        
        conversationsIds: this.conversationsIds,
      });
      this.conversationsIds = [];
    }, SYNC_MESSAGES_AFTER_CHECK_INTERVAL);
  }

  onReceivedMessageAccountCheck = ({ event, data } = {}) => {
    if (event != 'message_created_checker' && data?.conversation_id && data?.id) return;
    data.id = Number(data.id);
    data.conversation_id = Number(data.conversation_id);   
    setTimeout(() => {
      if (this.app.$store.getters['hasMessageIdInConversations'](data.id) == false) {
        this.conversationsIds = [...new Set([...this.conversationsIds, data.conversation_id])];
        this.initSyncChatMessageTimer();
      }
    }, AWAIT_CHECK_MESSAGE_INTERVAL);//tempo para que ocorra onMessageCreated e não gere sempre que nao exista   
  }

  onReconnect = () => {    
    this.syncActiveConversationMessages();
    clearTimeout(this.altertDisconnectedTimer);
    clearTimeout(this.syncReconnectTimer);
    window.bus.$emit(BUS_EVENTS.WEBSOCKET_RECONNECT, {type: 'websocket_reconnected'});
    if(this.lastDisconnectedAt){
      const jitter = Math.floor(Math.random() * SYNC_RECONNECT_MAX_JITTER_MS);
      const disconnectedAt = this.lastDisconnectedAt;
      this.syncReconnectTimer = setTimeout(() => {
        this.app.$store.dispatch('syncConversationsAfterWebsocketReconnect', {
          disconnectedAt,
        });
      }, jitter);
    }
    if(window.bus.$track){
      window.bus.$track('WEBSOCKET_RECONNECT', {
        account_id: this.app.$store.getters.getCurrentAccountId        
      });      
    }
  };

  onDisconnected = () => {
    this.lastDisconnectedAt = new Date().toISOString();    
    this.setActiveConversationLastMessageId();
    if(!conversationRoutes.includes(this.app.$route.name) && !boardRoutes.includes(this.app.$route.name)){
      return;
    }    
    this.altertDisconnectedTimer = setTimeout(() => {      
      window.bus.$emit(BUS_EVENTS.WEBSOCKET_DISCONNECT, {type: 'websocket_disconnected'});
    }, ALERT_DISCONNECTED_INTERVAL);
  };

  setActiveConversationLastMessageId = () => {
    const {
      params: { conversation_id },
    } = this.app.$route;
    if (conversation_id) {
      this.app.$store.dispatch('setConversationLastMessageId', {
        conversationId: Number(conversation_id),
      });
    }
  };

  syncActiveConversationMessages = () => {
    const {
      params: { conversation_id },
    } = this.app.$route;
    if (conversation_id) {
      this.app.$store.dispatch('syncActiveConversationMessages', {
        conversationId: Number(conversation_id),
      });
    }
    this.app.$store.dispatch('activeSyncConversationMessages', {skipConversationId: conversation_id ?? null});
  };

  isAValidEvent = data => {
    return this.app.$store.getters.getCurrentAccountId === data.account_id;
  };

  onMessageUpdated = data => {
    this.app.$store.dispatch('updateMessage', data);
    this.onMessageUpdatedUpdateSchedule(data);
  };

  onMessageUpdatedUpdateSchedule = data => {
    if (
      data.status === MESSAGE_STATUS.DELIVERED &&
      data.scheduled_message_id &&
      this.app.$store.getters?.getSelectedChat?.id === data.conversation_id
    ) {
      this.app.$store.dispatch('getScheduledMessage', data.conversation_id);
    }
  };

  onPresenceUpdate = data => {
    this.app.$store.dispatch('contacts/updatePresence', data.contacts);
    this.app.$store.dispatch('agents/updatePresence', data.users);
    this.app.$store.dispatch('setCurrentUserAvailability', data.users);
  };

  onConversationContactChange = payload => {
    const { meta = {}, id: conversationId } = payload;
    const { sender } = meta || {};
    if (conversationId) {
      this.app.$store.dispatch('updateConversationContact', {
        conversationId,
        ...sender,
      });
    }
  };

  onAssigneeChanged = payload => {
    const { id } = payload;
    if (id) {
      // Verifica se a conversa deve ser removida da lista do usuário atual
      if (shouldRemoveConversation(payload, this.app.$store)) {
        this.app.$store.commit('REMOVE_CONVERSATION', payload);
      } else {
        this.app.$store.dispatch('updateConversation', payload);
      }
    }
    this.fetchConversationStats();
    this.emitterFetchAllConversation(payload);
  };

  onConversationCreated = data => {
    this.app.$store.dispatch('addConversation', data);
    this.fetchConversationStats();
  };

  onConversationRead = data => {
    this.app.$store.dispatch('updateConversation', data);
  };

  onLogout = () => AuthAPI.logout();

  onInternalMessageCreated = data => {
    if (!this.isAValidEvent(data)) {
      return;
    }
    this.app.$store.dispatch('internalChat/handleIncomingMessage', data);
  };

  onInternalConversationRead = data => {
    if (!this.isAValidEvent(data)) {
      return;
    }
    this.app.$store.dispatch('internalChat/applyReadReceipt', data);
  };

  onMessageCreated = data => {
    DashboardAudioNotificationHelper.onNewMessage(data);
    this.app.$store.dispatch('addMessage', data);
  };

  onReload = () => window.location.reload();

  onStatusChange = data => {
    this.app.$store.dispatch('updateConversation', data);
    this.fetchConversationStats();
  };

  onConversationUpdated = data => {
    const { id } = data;

    // Verifica se a conversa existe na lista antes de processar remoção
    const conversationExists = this.app.$store.state.conversations.allConversations.some(
      c => c.id === id
    );

    if (id && shouldRemoveConversation(data, this.app.$store)) {
      if (conversationExists) {
        this.app.$store.commit('REMOVE_CONVERSATION', data);
      }
    } else {
      this.app.$store.dispatch('updateConversation', data);
    }
    this.fetchConversationStats();
    this.emitterFetchAllConversation(data);
  };

  onTypingOn = ({ conversation, user }) => {
    const conversationId = conversation.id;

    this.clearTimer(conversationId);
    this.app.$store.dispatch('conversationTypingStatus/create', {
      conversationId,
      user,
    });
    this.initTimer({ conversation, user });
  };

  onTypingOff = ({ conversation, user }) => {
    const conversationId = conversation.id;

    this.clearTimer(conversationId);
    this.app.$store.dispatch('conversationTypingStatus/destroy', {
      conversationId,
      user,
    });
  };

  onConversationMentioned = data => {
    this.app.$store.dispatch('addMentions', data);
  };

  onConversationMerge = data => {
    this.onReload();
  };

  onAssistentCreated = data => {
    this.app.$store.dispatch('assistent/get');
  };

  onTeamUpdated = data => {
    const { id } = data;
    if (id) {
      // Verifica se a conversa deve ser removida da lista do usuário atual
      // (ex: time privado onde o usuário não faz parte)
      if (shouldRemoveConversation(data, this.app.$store)) {
        this.app.$store.commit('REMOVE_CONVERSATION', data);
      } else {
        this.app.$store.dispatch('updateConversation', data);
      }
    }
    this.fetchConversationStats();
  };

  emitterFetchAllConversation = data => {
    const currentUser = this.app.$store.getters['getCurrentUser'];
    const hasCampaign = !!data.campaign_id; // Verifica se a conversa está associada a uma campanha
    const inboxIds = [2382, 2444, 2424, 2445, 2450]; // TODO: Remover depois

    const shouldEmit = (
      hasCampaign == false &&
      data.status == "open" &&
      data.meta.team && data.meta.team.private &&
      currentUser.role != "administrator" &&
      inboxIds.includes(data.inbox_id)
    );

    if (shouldEmit) {
      bus.$emit('fetch_conversation_stats');
      bus.$emit('fetch_all_conversation', data);
      bus.$emit('verify_conversation_team_private', data);
    }
  };

  onCallLogUpdated = data => {
    bus.$emit('calllog_updated', data);

    const calllogStatus = data?.calllog?.status;
    const calllogDirection = data?.calllog?.direction;
    const conversationPrimaryKey = Number(data?.calllog?.conversation_id);

    if (
      calllogStatus !== 'call_initiated' ||
      calllogDirection !== 'incoming' ||
      !conversationPrimaryKey
    ) {
      return;
    }

    const conversation = this.app.$store.getters.getConversationByPrimaryKey(
      conversationPrimaryKey
    );
    const currentUserId = this.app.$store.getters.getCurrentUserID;

    if (!conversation?.meta?.assignee || conversation.meta.assignee.id !== currentUserId) {
      return;
    }

    bus.$emit('open-call-modal', {
      conversationId: conversation.id,
      origin: 'incoming_auto',
    });
  }

  onWhatsappSyncFinished = data => {
    bus.$emit('whatsapp_sync_finished', data);
  }

  onOpportunityUpdated = data => {
    bus.$emit('opportunity_updated', data);
  }

  onOpportunityCreated = data => {
    bus.$emit('opportunity_created', {
      ...data,
      conversationId: data.conversation_id,
    });
    bus.$emit('opportunity_updated', data);
  };

  onOpportunityActivitiesChanged = data => {
    bus.$emit('opportunity_activities_changed', data);
  };

  onCampaignFileImportAnalyzed = data => {
    this.app.$store.dispatch(
      'campaigns/setCampaignFileAnalysis',
      data
    );
  }

  clearTimer = conversationId => {
    const timerEvent = this.CancelTyping[conversationId];

    if (timerEvent) {
      clearTimeout(timerEvent);
      this.CancelTyping[conversationId] = null;
    }
  };

  initTimer = ({ conversation, user }) => {
    const conversationId = conversation.id;
    // Turn off typing automatically after 30 seconds
    this.CancelTyping[conversationId] = setTimeout(() => {
      this.onTypingOff({ conversation, user });
    }, 30000);
  };

  fetchConversationStats = () => {    
    bus.$emit('fetch_conversation_stats');
    bus.$emit('fetch_overview_reports');
  };

  onContactDelete = data => {
    this.app.$store.dispatch(
      'contacts/deleteContactThroughConversations',
      data.id
    );
    this.fetchConversationStats();
  };

  onContactUpdate = data => {
    this.app.$store.dispatch('contacts/updateContact', data);
  };

  onNotificationCreated = data => {
    this.app.$store.dispatch('notifications/addNotification', data);
    bus.$emit('notification_created', data);
  };

  onFirstReplyCreated = () => {
    bus.$emit('fetch_overview_reports');
  };

  onCacheInvalidate = data => {
    const keys = data.cache_keys;
    this.app.$store.dispatch('labels/revalidate', { newKey: keys.label });
    this.app.$store.dispatch('inboxes/revalidate', { newKey: keys.inbox });
    this.app.$store.dispatch('teams/revalidate', { newKey: keys.team });
  };
}

export default {
  init(pubsubToken) {
    return new ActionCableConnector(window.WOOT, pubsubToken);
  },
};
